<script>
import { createEventDispatcher, onMount } from 'svelte'
import { get } from 'svelte/store'

import LoadPaypal from '$src/util/load-paypal.js'
import cart from '$src/store/cart.js'

const dispatch = createEventDispatcher()

onMount(async () => {
  const paypal = await LoadPaypal()
  paypal.Buttons({
    createOrder: (data, actions) => {
      const basket = get(cart)
      const total = basket.reduce((total, item) => {
        return total + item.price
      }, 0)

      return actions.order.create({
        application_context: {
          shipping_preference: 'NO_SHIPPING'
        },
        purchase_units: [{
          amount: {
            breakdown: {
              item_total: { value: total, currency_code: "USD" }
            },
            value: total
          },
          items: basket.map(item => {
            return {
              category: "DIGITAL_GOODS",
              name: item.name,
              description: item.option,
              unit_amount: { value: item.price, currency_code: "USD" },
              quantity: "1"
            }
          })
        }]
      })
    },
    onApprove: (data, actions) => {
      return actions.order.capture().then(details => {
        cart.set([])
        dispatch("paymentComplete")
      })
    },
    style: {
      color: "silver",
      label: "pay",
      layout: "horizontal",
      tagline: false
    }
  }).render('#checkout')
})
</script>

<h2>Ready to checkout?</h2>
<div id="checkout"></div>

<style>
#checkout {
  margin-top: 1em;
  max-width: 25em;
}
@media (max-width: 35em) {
  #checkout {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
